import React from 'react';
import { Swiper as OriginalSwiper } from 'antd-mobile';
const Swiper = (props) => {
    const { items, ...innerProps } = props;
    const getChildren = (items) => {
        return items.map((item) => (React.createElement(OriginalSwiper.Item, { onClick: item?.onclick }, item?.children)));
    };
    return (React.createElement(OriginalSwiper, Object.assign({}, innerProps), getChildren(items)));
};
export default Swiper;
